// src/components/FloatingWhatsAppButton.js
import React from "react";
import "../App.css";

const FloatingWhatsAppButton = () => {
  const whatsappNumber = "447508667276"; // ✅ no + for wa.me
  const defaultMessage =
    "Hello Ndils Daily Care, I would like to enquire about your care services.";

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        defaultMessage
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Ndils Daily Care on WhatsApp"
      className="floating-whatsapp-btn"
    >
      <span className="floating-whatsapp-icon">
        {/* ✅ WhatsApp SVG icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M16.04 3C9.4 3 4 8.33 4 14.88c0 2.6.86 5.01 2.34 6.99L4 29l7.35-2.3A12.3 12.3 0 0 0 16.04 27C22.68 27 28 21.67 28 15.12 28 8.33 22.68 3 16.04 3zm0 2.3c5.38 0 9.7 4.24 9.7 9.82 0 5.57-4.32 9.81-9.7 9.81-1.7 0-3.3-.43-4.72-1.24l-.34-.19-4.36 1.36 1.42-4.14-.22-.36a9.46 9.46 0 0 1-1.49-5.24c0-5.58 4.33-9.82 9.7-9.82zm-5.23 4.1c-.14 0-.37.05-.57.3-.2.25-.75.73-.75 1.78 0 1.06.77 2.08.88 2.22.11.15 1.51 2.42 3.75 3.39 2.24.96 2.24.64 2.65.6.41-.03 1.3-.53 1.49-1.04.18-.5.18-.93.13-1.02-.05-.08-.2-.13-.41-.23-.22-.11-1.3-.64-1.5-.71-.2-.07-.34-.11-.49.11-.15.23-.57.71-.7.86-.13.15-.26.17-.48.06-.22-.11-.93-.35-1.77-1.09-.65-.58-1.09-1.29-1.22-1.51-.13-.22-.01-.34.1-.45.1-.1.22-.26.33-.39.11-.13.15-.22.22-.37.07-.15.03-.28-.02-.39-.05-.11-.49-1.17-.67-1.6-.17-.41-.35-.36-.49-.37z"
          />
        </svg>
      </span>
      <span className="floating-whatsapp-label">WhatsApp Us</span>
    </a>
  );
};

export default FloatingWhatsAppButton;
